import angular from 'angular';
import jstz from "jstimezonedetect";
import uiBootstrap from 'angular-ui-bootstrap';
import uiMask from 'angular-ui-mask';

let cmsInputDate = function ($filter) {
    return {
        template: require('./date.html'),

        /**
         * @memberOf cms.input.date
         * @property {object}   scope.errors         Form errors object
         * @property {string}   scope.title          Input title and/or placeholder
         * @property {string}   scope.model          Input value reference
         * @property {function} scope.slugValidation Function that returns promise if slug is valid
         * @property {string}   scope.slugSource     Input value reference
         */
        scope: {
            errors: '=',
            model: '=',
            helper: '@',
            timePickerEnabled: '<',
            label: '@',
            aclShow: '<?',
            aclDisable: '<?'
        },

        link: function (scope) {

            /**
             * Pobiera ciąg hhmm z daty
             * @param date
             * @returns {*}
             */
            let getTimeString = function(date) {
                if(!date) {
                    return null;
                }
                return $filter('date')(date, "HHmm");
            };

            scope.$watch('model', function() {
                if(scope.model) {
                    scope.time = getTimeString(new Date(scope.model));
                    scope.date = new Date(scope.model);
                }
            });

            scope.dateChanged = function () {

                if(!scope.date) {
                    scope.time = null;
                    scope.model = null;
                    return;
                }

                if(!scope.time) {
                    scope.time = getTimeString(scope.date);
                }

                if(scope.date) {
                    scope.date.setHours(scope.time.substr(0,2));
                    scope.date.setMinutes(scope.time.substr(2,2));
                    scope.model = scope.date.toISOString();
                }

            };

            scope.timeChanged = function () {

                if(!scope.time) {
                    scope.date = null;
                    scope.model = null;
                    return;
                }

                if(!scope.date) {
                    scope.date = new Date();
                }

                scope.date.setHours(scope.time.substr(0, 2));
                scope.date.setMinutes(scope.time.substr(2, 2));
                scope.model = scope.date.toISOString();

            };

            /**
             * Make 23 from 24-29:xx hour
             */
            scope.validateTime = function() {
                if(scope.time) {
                    if(scope.time.substr(0,2) >= 23) {
                        scope.time = scope.time.replace(/^.{2}/g, '23');
                    }
                }
            };

            scope.userTz = jstz.determine().name();
        }
    };
};

/**
 * Datepicker control
 * @namespace cms.input.date
 */
export default angular.module('cms.input.date', [uiMask, uiBootstrap])
    .config(['uiMask.ConfigProvider', function(uiMaskConfigProvider) {
        uiMaskConfigProvider.maskDefinitions({
            '9': /\d/,
            '5': /[012345]/,
            '2': /[012]/
        });
        uiMaskConfigProvider.allowInvalidValue(true);
    }])
    .directive('cmsInputDate', cmsInputDate).name;



// WEBPACK FOOTER //
// ./src/cmsCore/Controls/DateControl/CmsInputDate.js